import { t } from 'i18next';
import { useState } from 'react';
import { SubTabs } from '../SubTabs';
import { SimpleButton } from '../styles';
import { Profile } from '~/helpers/userProfile';
import { NewTable } from '~/components';
import { ColumnsTable } from '../ClientPanel';
import { ApiResps } from '~/providers';
import { utilityNamesMap, utilityNamesMapReverse } from '~/pages/Analysis/DMTs/AcessorUtilities';

export const UtilityPanel = ({
  state,
  deleteUtility,
  openCreateEditUtility,
  profile,
  setState,
}: {
  state: {
    nobreaksColumns: ColumnsTable[];
    illuminationColumns: ColumnsTable[];
    defaultUtilitiesColumns: ColumnsTable[];
    escalatorElevatorColumns: ColumnsTable[];
    generatorColumns: ColumnsTable[];
    utilities: ApiResps['/dmt/get-utilities-list-client'],
  };
  profile: Profile;
  deleteUtility: (tab: string) => void;
  openCreateEditUtility: () => void;
  setState: (newState: { selectedUtility: string }) => void;
}): JSX.Element => {
  const [activeTab, setActiveTab] = useState(getUtilityName());

  function getUtilityName() {
    const key = Object.keys(utilityNamesMap)
      .find((k) => state.utilities?.[k]);
    return key ? utilityNamesMap[key] : t('nobreak');
  }

  function changeActiveTab(tab: string) {
    setActiveTab(tab);
    setState({ selectedUtility: tab });
  }
  function utilityButtons() {
    const disabled = state.utilities && !state.utilities[utilityNamesMapReverse[activeTab]]?.some((item) => item.checked);
    return [(
      <div style={{ float: 'right', marginBottom: '20px' }}>
        {(profile.manageAllClients) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" onClick={openCreateEditUtility}>{t('novoUtilitario').toUpperCase()}</SimpleButton>}
        {(profile.permissions.isAdminSistema) && <SimpleButton style={{ fontSize: '80%' }} variant="primary" disabled={disabled} onClick={() => deleteUtility(activeTab)}>{t('excluirUtilitarios')}</SimpleButton>}
      </div>
    )];
  }

  const tableConfig: Record<string, {
    data: any[];
    columns: any[];
    keySearch: string;
  }> = {
    Nobreak: {
      data: state.utilities.Nobreak || [],
      columns: state.defaultUtilitiesColumns,
      keySearch: 'searchNobreak',
    },
    Illumination: {
      data: state.utilities.Illumination || [],
      columns: state.illuminationColumns,
      keySearch: 'searchIllumination',
    },
    Elevator: {
      data: state.utilities.Elevator || [],
      columns: state.escalatorElevatorColumns,
      keySearch: 'searchElevator',
    },
    Escalator: {
      data: state.utilities.Escalator || [],
      columns: state.escalatorElevatorColumns,
      keySearch: 'searchEscalator',
    },
    'Fire Alarm': {
      data: state.utilities['Fire Alarm'] || [],
      columns: state.defaultUtilitiesColumns,
      keySearch: 'searchFireAlarm',
    },
    Generator: {
      data: state.utilities.Generator || [],
      columns: state.generatorColumns,
      keySearch: 'searchGenerator',
    },
    'Intrusion Alarm': {
      data: state.utilities['Intrusion Alarm'] || [],
      columns: state.defaultUtilitiesColumns,
      keySearch: 'searchIntrusionAlarm',
    },
    'Water Box': {
      data: state.utilities['Water Box'] || [],
      columns: state.defaultUtilitiesColumns,
      keySearch: 'searchWaterBox',
    },
  };

  return (
    <>
      <SubTabs
        tabs={Object.keys(state.utilities).sort((a, b) => (utilityNamesMap[a] || a).localeCompare(utilityNamesMap[b] || b)).map((item) => utilityNamesMap[item] || item)}
        activeTab={activeTab}
        onChange={changeActiveTab}
      />
      {activeTab && tableConfig[utilityNamesMapReverse[activeTab]] && (
        <NewTable
          data={tableConfig[utilityNamesMapReverse[activeTab]].data}
          columns={tableConfig[utilityNamesMapReverse[activeTab]].columns}
          pageSize={20}
          extraBtns={utilityButtons()}
          hideEmptyTable
          keySearch={tableConfig[utilityNamesMapReverse[activeTab]].keySearch}
        />
      )}
    </>
  );
};
